export default "__VITE_ASSET__C1bGoZ8h__"